module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chevron-left-double-31399dbb9809ed0f9be5a49bbc631b1b.svg";